import React from 'react'
import Layout from '../components/Layout'
import SEO from '../components/seo'

const About = () => (
    <Layout>
        <SEO title="About" />
        <h1>abou page</h1>
    </Layout>
)

export default About